import LABColor from '../classes/lab-color';

const lch2lab = ({ lightness: l, chroma, hue, alpha }) => {
  const hr = (hue / 360) * 2 * Math.PI;
  const a = chroma * Math.cos(hr);
  const b = chroma * Math.sin(hr);

  return new LABColor(l, a, b, alpha);
};

export default lch2lab;
